// inital JS load
(($) => {

    // when document ready,
    document.addEventListener('DOMContentLoaded', () => {

        if (!document.querySelector('.js-subnav-expand')) {
            return;
        }

        document.querySelectorAll('.js-subnav-expand').forEach(el => el.addEventListener('click', e => {
            e.preventDefault();

            var $parent = e.target.parentNode.parentNode.parentNode.parentNode;
            $parent.classList.toggle('-isExpanded');
            $parent.querySelector('.fa').classList.toggle('fa-plus');
            $parent.querySelector('.fa').classList.toggle('fa-minus');

        }));

    }, false);

})(jQuery);